import { render, staticRenderFns } from "./recharge_dashboard.vue?vue&type=template&id=4783b17a&scoped=true"
import script from "./recharge_dashboard.vue?vue&type=script&lang=js"
export * from "./recharge_dashboard.vue?vue&type=script&lang=js"
import style0 from "./recharge_dashboard.vue?vue&type=style&index=0&id=4783b17a&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/.pnpm/vue-loader@15.11.1_@vue+com_16d71e7cf8bf5c3e53d15d26d70867ca/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4783b17a",
  null
  
)

export default component.exports